import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row popover-main" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexPopover',
  setup(__props) {

const basicPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/basicPopover.vue"))
const directionPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/directionPopover.vue"))
const offsetPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/offsetPopover.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Popover"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicPopover)),
        _createVNode(_unref(directionPopover)),
        _createVNode(_unref(offsetPopover))
      ])
    ])
  ], 64))
}
}

})